import { Link } from "react-router-dom";
import { Reveal } from "@/components/landing/Reveal";

const A = ({ to, children, id }) => (
  <Link to={to} data-testid={id} className="text-[#5EE6D0] underline underline-offset-4 transition-colors hover:text-foreground">{children}</Link>
);

// The keyword-research guide publishes on 2026-11-04; link it only once it's live so no page points at an unpublished URL.
const KW_GUIDE_LIVE_AT = Date.parse("2026-11-04T00:00:00Z");

export const AboutAetherTags = () => (
  <div data-testid="about-aethertags">
    <Reveal>
      <p className="eyebrow">About AetherTags</p>
      <h2 className="mt-3 text-[2rem] sm:text-[2.75rem] leading-[1.04]">An Etsy SEO tool built for <span className="italic text-gold-grad">big catalogs.</span></h2>
      <div className="mt-5 space-y-4 text-[15px] text-muted-foreground leading-relaxed">
        <p>
          Most Etsy SEO advice assumes a shop with twenty listings and an afternoon to spare (our <A to="/blog/etsy-seo-complete-guide" id="about-pillar-link">complete guide to Etsy SEO</A> covers
          the basics). AetherTags is an Etsy SEO tool for the other kind:
          hundreds or thousands of listings, many never revisited. Good SEO for Etsy at that size means doing the basics everywhere, in the
          right order, without breaking what already sells.
        </p>
        <p>
          That is Etsy listing optimization at catalog scale. A Health Score ranks every listing, AI drafts titles, all 13 tags and attributes
          from your keywords, and you approve each change. When you bulk edit Etsy listings, the same rules apply to the whole batch, with a
          backup and undo. Try our free <A to="/tools" id="about-tools-link">Etsy tag generator and Etsy title generator</A> on one listing first.
        </p>
        <p>
          AetherTags doesn't replace Etsy keyword research; it puts it to work, and our
          {" "}{Date.now() >= KW_GUIDE_LIVE_AT
            ? <A to="/blog/etsy-keyword-research" id="about-keyword-guide-link">guide to Etsy keyword research</A>
            : <>guide to Etsy keyword research (coming soon)</>} shows free ways to start. It's shaped for print on demand, where many
          similar listings need distinct words, and vintage, where every one-of-a-kind find needs its own era, material and style.
        </p>
      </div>
    </Reveal>
  </div>
);
